import { isSameDay as isSameDay$1, isSameYear, getYear, getMonth, isBefore, startOfMonth, isAfter, startOfYear, startOfDay } from 'date-fns';

const normalizeDay = startOfDay;
function isInvalidDate(value) {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime());
  }
  if (typeof value === "number") {
    return Number.isNaN(value);
  }
  return true;
}
function isAfterDay(date, dateCompareTo) {
  return isAfter(normalizeDay(date), normalizeDay(dateCompareTo));
}
function isSameDay(date, dateCompareTo) {
  return dateCompareTo === null && date === null || dateCompareTo !== null && date !== null && isSameDay$1(dateCompareTo, date);
}
function isSameYearMonth(date, dateCompareTo) {
  return dateCompareTo === null && date === null || dateCompareTo !== null && date !== null && getYear(date) === getYear(dateCompareTo) && getMonth(date) === getMonth(dateCompareTo);
}
function isAfterYearMonth(...params) {
  return isAfter(startOfMonth(params[0]), startOfMonth(params[1]));
}
function isBeforeYearMonth(...params) {
  return isBefore(startOfMonth(params[0]), startOfMonth(params[1]));
}
function isAfterOrSameYearMonth(...params) {
  return isAfterYearMonth(...params) || isSameYearMonth(...params);
}
function isBeforeOrSameYearMonth(...params) {
  return isBeforeYearMonth(...params) || isSameYearMonth(...params);
}
function isAfterYear(...params) {
  return isAfter(startOfYear(params[0]), startOfYear(params[1]));
}
function isBeforeYear(...params) {
  return isBefore(startOfYear(params[0]), startOfYear(params[1]));
}
function isAfterOrSameYear(...params) {
  return isAfterYear(...params) || isSameYear(...params);
}
function isBeforeOrSameYear(...params) {
  return isBeforeYear(...params) || isSameYear(...params);
}
function onDateChangeWhenChanged(params, changeCallback) {
  const { date, changedDate } = params;
  if (isSameDay(date, changedDate)) {
    return;
  }
  changeCallback(changedDate);
}

export { isAfterDay, isAfterOrSameYear, isAfterOrSameYearMonth, isAfterYear, isAfterYearMonth, isBeforeOrSameYear, isBeforeOrSameYearMonth, isBeforeYear, isBeforeYearMonth, isInvalidDate, isSameDay, isSameYearMonth, onDateChangeWhenChanged };
//# sourceMappingURL=date.mjs.map
